import React from 'react';
import { LazyLoad } from '../../common/Functions'

function Home_Projects() {
  return (
    <div className="max-w-screen-xl	mx-auto home-projects text-center">
      <main className="my-10">
        <p className="font-bold text-sm py-6">I'VE WORKED ON PROJECTS FOR</p>
        <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-center py-10 px-0">
          <Container>
            <LazyLoad src={require('../../common/images/home/pragtech.png')} alt="Pragtechnologies Logo" className="w-9/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/seeyoudoc.svg')} alt="Seeyoudoc Logo" className="w-6/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/leocoders.png')} alt="LeoCoders Logo" className="w-6/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/eo.png')} alt="EO Logo" className="w-6/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/simmons.png')} alt="Simmons Consult Logo" className="w-6/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/metroantipolo.png')} alt="Metro Antipolo Logo" className="w-4/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/aims.png')} alt="AIMS Logo" className="w-2/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/mvms.png')} alt="MVMS Logo" className="w-2/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/marikina.png')} alt="Marikina City Logo" className="w-2/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/nac.png')} alt="NAC Logo" className="w-2/12 self-center" />
          </Container>
          <Container>
            <LazyLoad src={require('../../common/images/home/pxp.png')} alt="PXP Energy Logo" className="w-2/12 self-center" />
          </Container>
        </div>
      </main>
    </div>
  )
}

const Container = ({children}) => {
 return(
    <div className="w-64 h-24 max-h-24 overflow-hidden rounded-lg bg-white flex flex-col justify-center items-center m-1">
      {children}
    </div>
  )
}

export default Home_Projects;
